import { NavLink } from "react-router-dom";
import {
    LayoutDashboard,
    FolderKanban,
    Users,
    Settings,
    Sparkles,
    BarChart3,
    DatabaseZap,
    ShieldCheck,
    KanbanSquare,
    Building2,
    FileSearch,
    BriefcaseBusiness,
    LifeBuoy,
    BookOpen
} from "lucide-react";
import { clientNavItems, superAdminNavItems, agencyNavItems } from "../../data/navItems";
import {
    getSession,
    canManageSeeds,
    canViewLeads,
    canManageLeads,
    canViewAccounts,
    isAgencyUser,
    getWorkspaceLabel,
    getBrandDisplayName,
    getBrandInitials
} from "../../services/authService";

function resolveIcon(label = "") {
    const key = label.toLowerCase();

    if (key.includes("account") || key.includes("client")) return Users;
    if (key.includes("dashboard")) return LayoutDashboard;
    if (key.includes("project")) return FolderKanban;
    if (key.includes("lead")) return Users;
    if (key.includes("kanban")) return KanbanSquare;
    if (key.includes("variant")) return BarChart3;
    if (key.includes("seed")) return DatabaseZap;
    if (key.includes("setting")) return Settings;
    if (key.includes("system") || key.includes("log")) return FileSearch;
    if (key.includes("job")) return BriefcaseBusiness;
    if (key.includes("ai") || key.includes("provider")) return Sparkles;
    if (key.includes("knowledge")) return BookOpen;
    if (key.includes("support") || key.includes("help")) return LifeBuoy;

    return Sparkles;
}

function canShowNavItem(item) {
    const permission = item?.permission;
    const user = getSession();

    if (!permission || permission === "dashboard" || permission === "projects:view") {
        return true;
    }

    if (permission === "seeds:manage") return canManageSeeds();
    if (permission === "leads:view") return canViewLeads();
    if (permission === "leads:manage") return canManageLeads();
    if (permission === "accounts:view") return canViewAccounts();
    if (permission === "accounts:manage") return canViewAccounts();
    if (permission === "system-logs:view") return user?.isSuperAdmin === true;
    if (permission === "platform-jobs:manage") return user?.isSuperAdmin === true;
    if (permission === "support:view") return true;
    if (permission === "support:manage") return user?.isSuperAdmin === true;

    return true;
}

export default function Sidebar({ onNavigate }) {
    const user = getSession();

    const baseNavItems = user?.isSuperAdmin
        ? superAdminNavItems
        : isAgencyUser()
            ? agencyNavItems
            : clientNavItems;

    const navItems = baseNavItems.filter(canShowNavItem);

    const brandName = getBrandDisplayName();
    const brandInitials = getBrandInitials();
    const workspaceLabel = getWorkspaceLabel();

    const statusTitle = user?.isSuperAdmin
        ? "Platform Mode"
        : isAgencyUser()
            ? "Agency Mode"
            : "Client Mode";

    const statusSubtitle = user?.isSuperAdmin
        ? "Global ops"
        : isAgencyUser()
            ? "Client portfolio"
            : "Website workspace";

    return (
        <aside className="crm-sidebar-premium">
            <div className="crm-sidebar-inner">
                <div className="crm-brand-premium compact">
                    <div className="crm-brand-mark-premium compact">
                        {user?.logoUrl ? (
                            <img src={user.logoUrl} alt="logo" />
                        ) : (
                            <span>{brandInitials}</span>
                        )}
                    </div>

                    <div className="crm-brand-copy compact">
                        <strong>{brandName}</strong>
                        <span>{workspaceLabel}</span>
                    </div>
                </div>

                <nav className="crm-nav-premium">
                    {navItems.map((item) => {
                        const Icon = resolveIcon(item.label);

                        return (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                onClick={onNavigate}
                                className={({ isActive }) =>
                                    `crm-nav-link-premium ${isActive ? "active" : ""}`
                                }
                            >
                                <span className="crm-nav-icon-premium">
                                    <Icon size={18} />
                                </span>

                                <span className="crm-nav-label-premium">
                                    {item.label}
                                </span>
                            </NavLink>
                        );
                    })}
                </nav>

                <div className="crm-sidebar-status premium">
                    <div className="crm-sidebar-status-icon">
                        {isAgencyUser() ? <Building2 size={16} /> : <ShieldCheck size={16} />}
                    </div>

                    <div className="crm-sidebar-status-copy">
                        <span>{statusTitle}</span>
                        <strong>{statusSubtitle}</strong>
                    </div>
                </div>
            </div>
        </aside>
    );
}